import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AddMoreDataButton from '../../../../components/addMoreDataButton/AddMoreDataButton';

import editDocumentActions from '../../store/actions/edit-document.actions';
import tableStyles from '../table.module.scss';
import documentEditMode from '../../constants/documentEditMode';
import useUserRoleInDoc from '../../hooks/useUserRoleInDoc';
import roles from '../../constants/roles';
import RemovableWorker from '../../RemovableWorker/RemovableWorker';
import getName from '../../../../helpers/getName';

const AppointedWorkersCell = memo(({ rowOpened, record, single }) => {
  const dispatch = useDispatch();
  const userRole = useUserRoleInDoc(record);
  // const allowChange = userRole === roles.RESPONSIBLE_OR_AUTHOR;

  const handleAddExecuter = useCallback(
    (e) => {
      e.stopPropagation();
      dispatch(
        editDocumentActions.openModal({
          ...record,
          editMode: documentEditMode.EXECUTER,
        })
      );
    },
    [record]
  );

  return (
    <>
      {single && (
        <OneAppointedWorker
          single={single}
          rowOpened={rowOpened}
          appointedWorker={record.appointedWorkers?.[0]}
          record={record}
          allowDelete={rowOpened && record.appointedWorkers?.[0]}
          //  allowDelete={rowOpened && record.appointedWorkers?.[0] && allowChange}
        />
      )}
      {!single && rowOpened && record.appointedWorkers?.length > 1 && (
        <div
          className={tableStyles.tdList}
          style={{ marginTop: '10px', maxHeight: '150px', overflowY: 'auto' }}
        >
          {record.appointedWorkers.slice(1).map((appointedWorker) => {
            return (
              <OneAppointedWorker
                key={`${appointedWorker.id}_${record.id}`}
                appointedWorker={appointedWorker}
                record={record}
                rowOpened={rowOpened}
                // allowDelete={rowOpened && appointedWorker && allowChange}
                allowDelete={rowOpened && appointedWorker}
              />
            );
          })}
        </div>
      )}
      {/* {!single && rowOpened && allowChange && (
        <AddMoreDataButton
          text="Добавить исполнителей"
          onClick={handleAddExecuter}
        />
      )} */}
      {!single && rowOpened && (
        <AddMoreDataButton
          text="Добавить исполнителей"
          onClick={handleAddExecuter}
        />
      )}
    </>
  );
});

function OneAppointedWorker({
  record,
  appointedWorker,
  rowOpened,
  single,
  allowDelete,
}) {
  const dispatch = useDispatch();
  const counter = record.appoinedWorkersQuantity - 1;
  const appointedWorkersCounterText =
    counter > 0 && !rowOpened ? `(+${counter})` : '';

  const handleConfirm = () => {
    dispatch(
      editDocumentActions.deleteExecuter(appointedWorker?.id, record.id)
    );
  };

  return (
    <RemovableWorker
      allowDelete={allowDelete}
      single={single}
      counter={appointedWorkersCounterText}
      onConfirm={handleConfirm}
      deleteConfirmText={
        <span>
          Удалить исполнителя: <strong>{getName(appointedWorker)}</strong>?
        </span>
      }
      person={appointedWorker}
    />
  );
}

export default AppointedWorkersCell;
